import { useEffect, useState } from "react";
import type { RoadmapFilterOptions } from "../api/generated/contracts";
import { roadmapApi } from "../api/roadmap";
import { useInvalidation } from "../realtime/useInvalidation";

/**
 * The roadmap filter bar's vocabulary (GET /api/roadmap/filters) - team groups, statuses, teams
 * and their match counts, per RoadmapController.cs. Re-fetched on any push-channel invalidation
 * so an admin's reference-data edit (a `ConfigurationManager` write) reaches an open filter bar
 * without a manual reload.
 */
export function useReferenceData(): { options: RoadmapFilterOptions | null; loading: boolean } {
  const [options, setOptions] = useState<RoadmapFilterOptions | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    setLoading(true);
    void roadmapApi
      .getFilterOptions()
      .then(setOptions)
      .catch(() => {
        // A failed filter-options fetch is not fatal to the caller (e.g. RoadmapPage still
        // renders the board without a filter bar) - the next invalidation retries it, matching
        // useFreshness's own non-fatal-poll posture.
      })
      .finally(() => setLoading(false));
  };

  useEffect(refresh, []);
  useInvalidation(refresh);

  return { options, loading };
}
